import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { useParams, useLocation } from "react-router-dom";
import { diet, dietTaste } from "../../Utills/enums";
import { removeItem, editMenuItem, updateItem, fetchMenuItem, openGlobalPopup } from '../../redux/action';
import CommonSearchBox from "../../component/SearchBox/CommomSearchBox";
import ConfirmBox from "../../component/Popup/ConfirmBox";
import { IMAGE_BASE_URL } from '../../Utills/config';
import { useTranslation } from "react-i18next";
import EmptyScreen from "../../component/common/EmptyScreen";

const API_BASE_URL = IMAGE_BASE_URL;

function FoodList() {
  const { t } = useTranslation();
  const { id, locationId } = useParams(); // category id from route
  const location = useLocation();
  const foodsObj = useSelector((state) => state.admin?.foodItems) || [];
  const foods = Array.isArray(foodsObj) ? foodsObj : Object.values(foodsObj || {});
  const { category, allCategories } = location.state || {};
  const [search, setSearch] = useState("");
  const [deleteFood, setIsDeleteFood] = useState('');
  console.log("foods", foods)
  const dispatch = useDispatch();

  useEffect(() => {
    if (category?.categoryId) {
      dispatch(fetchMenuItem(category.categoryId));
    }
  }, [category?.categoryId, dispatch]);

  const filteredfoods = Object.values(foods).filter((food) =>
    String(food?.foodName || "").toLowerCase().includes(search.toLowerCase()) ||
    String(food?.price ?? "").toLowerCase().includes(search.toLowerCase()) ||
    String(diet[food?.foodTypeId] || "").toLowerCase().includes(search.toLowerCase()) ||
    String(dietTaste[food?.foodTasteId] || "").toLowerCase().includes(search.toLowerCase())
  );

  const handleDelete = (menuId, categoryId) => {
    setIsDeleteFood({ menuId, categoryId });
    dispatch(openGlobalPopup("confirm-box"));
  };

  const handleEdit = (food) => {
    // In a real application, you'd usually open a modal or navigate to an edit form.
    // For demonstration, we'll use a prompt to simulate getting new data.
    console.log('food', food)
    dispatch(editMenuItem(food));
    dispatch(openGlobalPopup("food-item-form"));
  };

  const getImageUrl = (imagePath) => {
  if (!imagePath) {
    return "https://dummyimage.com/400x300/cccccc/000000&text=No+Image"; // Fallback image
  }
  
  // If it's already a full http/https link (e.g. stock gallery or external link)
  if (imagePath.startsWith("http://") || imagePath.startsWith("https://")) {
    return imagePath;
  }

  // Prepend API base domain to relative path
  return `${API_BASE_URL}${imagePath.startsWith('/') ? '' : '/'}${imagePath}`;
};

  return (
    <div className="table-container">
      <h3 style={{ padding: "0px 0px 0px 10px" }}>{t("Foods in Category")} {category?.categoryName || t("Unknown")} ({Object.keys(filteredfoods).length})</h3>
      <CommonSearchBox
        placeholder="Search food Item by name, price, food type..."
        search={search}
        setSearch={setSearch}
      />
      {Object.keys(filteredfoods).length === 0 ? (
        <EmptyScreen
          message={foods.length ? "No matching food items found." : "No food items in this category yet."}
          subText={foods.length ? "Clear the search or try another name, price or food type." : "Use Add Food Item to create the first item in this category."}
          actionLabel={foods.length && search ? "Clear search" : undefined}
          onAction={foods.length && search ? () => setSearch("") : undefined}
        />
      ) : (
        <div className="table-wrapper">
          <table className="table">
            <thead>
              <tr>
                <th>Image</th>
                <th>Name</th>
                <th>Price</th>
                <th>Food Type</th>
                <th>Food Taste</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredfoods.map((food) => (
                <tr key={food.menuId}>
                  <td> <img src={getImageUrl(food.imageUrl)} title="" alt="" className="itemImage" /></td>
                  <td>{food.foodName}</td>
                  {food.menuSizeOptions?.length > 0 ? (
                          <>
                          <td>
  {food.menuSizeOptions.map((m) => `₹${m.price}`).join(", ")}
</td>

                          </>
                        ) : (
                          <td>₹{food.price}</td>
                        )}

                  
                  <td>{diet[food.foodTypeId]}</td>
                  {/* <td>{dietTaste[food.foodTasteId]}</td> */}
                  <td>
  {food.foodTasteMapping && food.foodTasteMapping.length > 0 ? (
    <div className="taste-badge-container">
      {food.foodTasteMapping
        .filter(mapping => mapping.isActive) // Only show active tastes
        .map((mapping, index) => (
          <span key={index} className="taste-badge">
            {dietTaste[mapping.foodTasteId]}
            {index < food.foodTasteMapping.length - 1 ? ", " : ""}
          </span>
        ))}
    </div>
  ) : (
    <span className="text-muted">No Labels</span>
  )}
</td>
                  <td>
                    {/* <button
                onClick={() => handleEdit(food)}
                style={{ ...styles.actionButton, backgroundColor: '#0078d4' }}>Edit</button>
                <button
                onClick={() => handleDelete(food.menuId, food.categoryId)}
                style={{ ...styles.actionButton, backgroundColor: '#dc3545' }}>Delete</button> */}

                    <span
                      className="edit-icon link-btn"
                      title="Edit"
                      aria-label="Edit"
                      onClick={() => handleEdit(food)}
                    >
                      ✎
                    </span>

                    <span
                      className="delete-icon link-btn danger"
                      title="Delete"
                      aria-label="Delete"
                      onClick={() => handleDelete(food.menuId, food.categoryId)}
                    >
                      ✖
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      <ConfirmBox
        variant="delete"
        title="Are you sure you want to delete this food item?"
        onConfirm={() => {
          if (deleteFood) {
            dispatch(removeItem(deleteFood));
          }
        }}
        onCancel={() => {
          setIsDeleteFood('');
        }}
      />
    </div>
  );
}
export default FoodList;
